import { useResponsive } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Divider, Grid, Stack } from '@mui/material';
import { memo } from 'react';
import { ChangeEmail } from './components/change-email';
import { ChangePassword } from './components/change-password';
import { UserInformation } from './components/user-information';
import * as Styled from './styles';
import * as SX from './sx';
import type { AccountOverviewProps as Props } from './types';

export const AccountOverview = memo(({ className }: Props) => {
  const isSmall = useResponsive('down', 'smplus');

  return (
    <Styled.Wrapper
      className={classnames('AccountOverview', className)}
      sx={SX.root}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={isSmall ? 12 : 5} lg={5}>
          <UserInformation />
        </Grid>
        <Grid item xs={12} sm={12} md={isSmall ? 12 : 7} lg={7}>
          <Stack sx={SX.content}>
            <Grid item xs={12} sm={12} md={isSmall ? 12 : 5} lg={5}>
              <ChangeEmail />
            </Grid>
            <Divider
              orientation="vertical"
              variant="middle"
              sx={{ height: 'auto' }}
            />
            <Grid item xs={12} sm={12} md={isSmall ? 12 : 7} lg={7}>
              <ChangePassword />
            </Grid>
          </Stack>
        </Grid>
      </Grid>
    </Styled.Wrapper>
  );
});

AccountOverview.displayName = 'AccountOverview';
